const kformBuilderOptionInputsLabelPositionController = /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.inputsLabelPosition = [
		{
			value: 'top',
			title: 'Top',
		},
		{
			value: 'left',
			title: 'Left',
		},
		{
			value: 'right',
			title: 'Right',
		},
		{
			value: 'bottom',
			title: 'Bottom',
		},
	];

	if (!$scope.component.inputsLabelPosition) {
		$scope.component.inputsLabelPosition = 'top';
	}
};

export default kformBuilderOptionInputsLabelPositionController;
